// extracted by mini-css-extract-plugin
export default {"check":"CheckMark_check__dvSHV","sm":"CheckMark_sm__Vm4mZ"};